export default __webpack_public_path__ + "static/media/gallery1.501d2498.png";